import { OrganizationFormData, CharityInfo } from "../types";
import { organizationTypeOptions } from "../organizationDetailsForm";

export const transformFormDataToCharityInfo = (
  formData: OrganizationFormData
): CharityInfo => {
  return {
    entityType: formData.organizationType?.value || "",
    name: formData.organizationName,
    legalName: formData.legalOrganizationName,
    ein: formData.organizationEINNumber,
    einIssuingCountry: formData.country?.value || "US",
    addressDetails: {
      addressLine1: formData.addressLine1,
      addressLine2: formData.addressLine2 || "",
      city: formData.addressCity?.value || "",
      state: formData.addressStateProvince?.value || "",
      postalCode: formData.addressPostalCode,
      country: formData.country?.value || "US",
    },
    textName: formData.organizationName,
    privacyPolicyUrl: formData.privacyPolicyUrl,
    termsAndConditionsUrl: formData.termsAndConditionUrl,
    contactNumber: formData.contactNumber,
    contactEmail: formData.contactEmail,
    siteUrl: formData.organizationWebsiteUrl,
  };
};

export const transformCharityInfoToFormData = (
  charityInfo: CharityInfo
): Partial<OrganizationFormData> => {
  return {
    organizationType: charityInfo.entityType
      ? organizationTypeOptions.find(opt => opt.value === charityInfo.entityType) ||
        { value: charityInfo.entityType, label: charityInfo.entityType }
      : undefined,
    organizationName: charityInfo.name,
    legalOrganizationName: charityInfo.legalName,
    organizationEINNumber: charityInfo.ein,
    country: charityInfo.addressDetails?.country ? { value: charityInfo.addressDetails.country, label: charityInfo.addressDetails.country } : undefined,
    addressLine1: charityInfo.addressDetails?.addressLine1,
    addressLine2: charityInfo.addressDetails?.addressLine2,
    addressCity: charityInfo.addressDetails?.city ? { value: charityInfo.addressDetails.city, label: charityInfo.addressDetails.city } : undefined,
    addressStateProvince: charityInfo.addressDetails?.state ? { value: charityInfo.addressDetails.state, label: charityInfo.addressDetails.state } : undefined,
    addressPostalCode: charityInfo.addressDetails?.postalCode,
    privacyPolicyUrl: charityInfo.privacyPolicyUrl,
    termsAndConditionUrl: charityInfo.termsAndConditionsUrl,
    contactNumber: charityInfo.contactNumber,
    contactEmail: charityInfo.contactEmail,
    organizationWebsiteUrl: charityInfo.siteUrl,
  };
};